/** Auto-generated by scripts/generate-bogof-eligible-slugs.js */
export const ONLINE_BOGOF_ELIGIBLE_SLUGS = new Set<string>([
  "bb-glow-foundation",
  "biotin-intramuscular-injection-online-training",
  "brow-lamination",
  "chemical-skin-peels",
  "dermaplaning",
  "face-and-body-waxing",
  "facial-anatomy-and-physiology-level-3",
  "facial-and-skin-online-training-bundle",
  "glutathione-intramuscular-injection-online-training",
  "high-definition-brows-training",
  "lash-lift-and-tint",
  "lemon-bottle-fat-dissolving-training",
  "microneedling",
  "online-8-point-lift-training",
  "online-advanced-anti-wrinkle-injections",
  "online-aqualyx-and-deso-fat-dissolving-training",
  "online-bio-stimulators-sculptra-and-aesplla-training",
  "online-body-contouring-radio-frequency-and-ultrasound-training",
  "online-cryotherapy-fat-freezing-training-course",
  "online-elective-and-emergency-dissolving-and-complications",
  "online-face-and-body-profhilo",
  "online-foundation-anti-wrinkle-injections-training-course",
  "online-foundation-lip-filler-training",
  "online-hifu-training",
  "online-jalupro-classic-or-hmw-or-super-hydro",
  "online-led-light-therapy-training-course",
  "online-lemon-bottle-skin-booster-training",
  "online-lidocaine-infusion-training",
  "online-lumi-eyes-training-course",
  "online-lymphatic-drainage-massage-training-course",
  "online-mesotherapy-training",
  "online-mesotoxin-training",
  "online-pdo-cog-threads-training",
  "online-pdo-mono-threads-training",
  "online-phlebotomy-training-course",
  "online-plasma-fibroblast-training",
  "online-polynucleotides-training",
  "online-profhilo-structura-training-course",
  "online-prp-vampire-facial-training-course",
  "online-radio-frequency-skin-tightening-training-course",
  "online-sclerotherapy-training",
  "online-sunekos-200-and-1200-course",
  "online-tear-trough-training",
  "online-temple-filler-training",
  "online-vitamin-b12-injection",
  "online-vitamin-c-injection",
  "online-wood-therapy-training-course",
  "skin-booster-online-training-bundle",
  "vitamin-drip-and-injections-online-training-bundle",
  "vtct-itec-level-4-award-in-core-of-knowledge-for-laser-and-light-devices",
  "vtct-itec-level-4-award-in-principles-and-practice-of-aesthetic-therapies",
  "vtct-level-3-award-in-anatomical-and-physiological-knowledge-of-body",
]);

export function isOnlineBogofEligibleSlugClient(slug: string): boolean {
  return ONLINE_BOGOF_ELIGIBLE_SLUGS.has(slug.trim().toLowerCase());
}
